<template>
  <div class="phone-preview">
    <div class="phone-preview__top-bar"></div>
    <div class="phone-preview__sleep"></div>
    <div class="phone-preview__bottom-bar"></div>
    <div class="phone-preview__power"></div>
    <div class="phone-preview__volume-up"></div>
    <div class="phone-preview__volume-down"></div>
    <div class="phone-preview__overflow"></div>
    <div class="phone-preview__inner-shadow"></div>
    <div class="phone-preview__screen">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.phone-preview {
  width: 320px;
  height: 600px;
  padding: 14px;
  background: #fdfdfd;
  box-shadow: inset 0 0 11px 0 black;
  border-radius: 33px;
  position: relative;
  &::before {
    width: calc(100% - 8px);
    height: calc(100% - 8px);
    position: absolute;
    top: 4px;
    content: '';
    left: 4px;
    border-radius: 29px;
    background: black;
    z-index: 1;
  }
  &__overflow {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 44px;
    overflow: hidden;
  }
  &__inner-shadow {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    position: absolute;
    top: 10px;
    overflow: hidden;
    left: 10px;
    border-radius: 22px;
    box-shadow: inset 0 0 15px 0 rgb(255 255 255 / 5%);
    z-index: 1;
    &::before {
      box-shadow: inset 0 0 18px 0 rgba(#fff, 0.75);
      width: 100%;
      height: 116%;
      position: absolute;
      top: -8%;
      content: '';
      left: 0;
      border-radius: 220px / 100px;
      z-index: 2;
    }
  }
  &__screen {
    box-shadow: none;
    position: relative;
    width: 100%;
    position: relative;
    height: 100%;
    z-index: 3;
    background: white;
    display: block;
    overflow: hidden;
    border-radius: 22px;
  }
  &__top-bar,
  &__bottom-bar {
    width: 100%;
    position: absolute;
    height: 8px;
    background: rgba(0, 0, 0, 0.1);
    left: 0;
  }
  &__top-bar {
    top: 80px;
  }
  &__bottom-bar {
    bottom: 80px;
  }
  &__volume-up,
  &__volume-down,
  &__power,
  &__sleep {
    width: 5px;
    background: #b2b2b2;
    position: absolute;
  }

  &__power {
    left: -3px;
    top: 20%;
    height: 5.54%;
  }
  &__volume-up {
    left: -3px;
    top: 30%;
    height: 11%;
  }
  &__volume-down {
    left: -3px;
    top: 43%;
    height: 10%;
  }
  &__sleep {
    top: 38%;
    bottom: 42%;
    right: -3px;
  }
}
</style>
